<template>
	<el-dialog :visible="visible" title="商品详情" @close="$emit('close')" top="5vh" width="1200px">
		<div>
			<WmsTable :columns="columns" :isPagination="false" :hasHeader="false" :dataSource="data" isExpanded_hidden
				rowKey="orderNo" :scrollY="650" style="height:700px">
				<ImgView slot="specialCheckRequirementImg" slot-scope="{text, record, index}" :src="text" />
				<template slot="expandedRender" slot-scope="{ record }">
					<WmsTable :columns="columns_addition" :isPagination="false" :hasHeader="false"
						:dataSource="record.additionList" :scrollY="400">
						<ImgView slot="ingredientsImg" slot-scope="{text, record, index}" :src="text" />
					</WmsTable>
				</template>
			</WmsTable>
		</div>
	</el-dialog>
</template>

<script>

import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
export default {
	name: "InterBtnBox",
	components: { WmsTable, ImgView },
	data() {
		return {
			columns: [
				{
					title: "订单号",
					key: "platformOrderNo",
					dataIndex: "platformOrderNo",
					rowKey: "key",
				},
				{
					title: "收货国家",
					key: "receivingNationName",
					dataIndex: "receivingNationName",
					rowKey: "key",
          width:150
				},
				{
					title: "数量",
					key: "num",
					dataIndex: "num",
					rowKey: "key",
          width:100
				},
				{
					title: "商品类型",
					key: "productType",
					dataIndex: "productType",
					rowKey: "key",
          customRender: (text,record,index)=>{
            return {1:'普通商品',2:'OEM商品',3:'组合商品'}[text]
          }
				},
				{
					title: "附加项数量",
					key: "additionNums",
					dataIndex: "additionNums",
					rowKey: "key",
          width:110
				},
				{
					title: "特殊质检要求",
					key: "specialCheckRequirement",
					dataIndex: "specialCheckRequirement",
					rowKey: "key",
				},
				{
					title: "特殊要求图片",
					key: "specialCheckRequirementImg",
					dataIndex: "specialCheckRequirementImg",
					rowKey: "key",
					scopedSlots: {
						customRender: "specialCheckRequirementImg",
					},
				},
			],
			columns_addition: [
				{
					title: "附加项名称",
					key: "additionName",
					dataIndex: "additionName",
					rowKey: "key",
				},
				{
					title: "辅料名称",
					key: "ingredientsNameJp",
					dataIndex: "ingredientsNameJp",
					rowKey: "key",
				},
				{
					title: "辅料图片",
					key: "ingredientsImg",
					dataIndex: "ingredientsImg",
					rowKey: "key",
					scopedSlots: {
						customRender: "ingredientsImg",
					},
				},
				{
					title: "辅料库位",
					key: "gridCode",
					dataIndex: "gridCode",
					rowKey: "key",
				},
			]
		};
	},
	props: {
		visible: {
			type: Boolean,
			default: () => false
		},
		data: {
			type: Array,
			default: () => []
		}
	},
	computed: {
	},
	methods: {
	},
};
</script>

<style scoped>
.dialogTitle {
	height: 60px;
	width: 100%;
	font-size: 20px;
	text-align: center;
	line-height: 60px;
	background-color: #00284d;
	color: #e8e8e8;
}
</style>
